export const AUTH_ROUTES = {
  LOGIN: '/login',
  CODE_FLOW_CALLBACK: '/code-flow-callback',
  LOGOUT: '/logout',
} as const;
